<template>
  <b-alert v-if="visible" show variant="warning" dismissible class="timezone-stale-notice mb-0" @dismissed="dismiss">
    <strong>Your browser's time zone data is out of date.</strong>
    It reads {{ zonesText }}, so booking times there can show an hour off. Update your browser or
    operating system, then reload the page.
  </b-alert>
</template>

<script>
import { mapGetters } from 'vuex'
import { timezoneCity } from '@/components/desk/utils'

const STORAGE_KEY = 'timezoneStaleNoticeDismissed'

const offsetLabel = (seconds) => {
  const sign = seconds < 0 ? '-' : '+'
  const abs = Math.abs(seconds)
  const minutes = Math.floor((abs % 3600) / 60)
  return `UTC${sign}${Math.floor(abs / 3600)}${minutes ? ':' + String(minutes).padStart(2, '0') : ''}`
}

// what the viewer closed: the stale set it was shown, so a newly stale zone shows again
const readDismissed = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch (e) {
    return null
  }
}

export default {
  name: 'TimezoneStaleNotice',
  data: () => ({
    dismissed: readDismissed()
  }),
  computed: {
    ...mapGetters('timezone', ['staleBuildingTimezones']),
    signature() {
      return this.staleBuildingTimezones.map((zone) => zone.id).join(',')
    },
    visible() {
      return this.staleBuildingTimezones.length > 0 && this.dismissed !== this.signature
    },
    zonesText() {
      return this.staleBuildingTimezones
        .map((zone) => `${timezoneCity(zone.id)} at ${offsetLabel(zone.browser)} instead of ${offsetLabel(zone.server)}`)
        .join(', ')
    }
  },
  methods: {
    dismiss() {
      this.dismissed = this.signature
      try {
        window.sessionStorage.setItem(STORAGE_KEY, this.signature)
      } catch (e) {
        // private mode or blocked storage: it stays closed for this page only
      }
    }
  }
}
</script>

<style>
.timezone-stale-notice {
  border-radius: 0;
}
</style>
